import { render } from "./NurseryHours.vue?vue&type=template&id=1807b24c&ts=true"
import script from "./NurseryHours.vue?vue&type=script&lang=ts"
export * from "./NurseryHours.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__